import { Button } from "@Components/CustomButton/Button"
import CustomEmptyData from "@Components/CustomEmptyData"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import CustomBottomModal from "@Components/Modal/CustomBottomModal/CustomBottomModal"
import { Spacer } from "@Components/Space"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { baseColors } from "@Constants/baseStyles"
import { ConstantsContext } from "@Providers/ConstantsProvider"
import { FollowUpContext } from "@Providers/FollowUpProvider"
import { userAtom } from "@Recoil/Atom/userAtom"
import { LocalStorage } from "@Services/sharedPreferences/localStorage"
import { UserService } from "@Services/User.service"
import React, { useContext, useEffect, useState } from "react"
import { FlatList, RefreshControl, TouchableOpacity, View } from "react-native"
import { Checkbox } from "react-native-paper"
import { useRecoilValue } from "recoil"
import { ConstantLineChart } from "./ConstantsLineChart"
import CustomCheckBox from "@Components/CustomCheckBox/CustomCheckBox"

export const ConstantsFollowUpChart = ({
    toggleModal,
    openDeleteModal,
    constantWithValues,
    loading,
    setConstantWithValues,
    fetchConstants
}) => {
    const { setConstantDate } = useContext(FollowUpContext)
    const { setUpdateList } = useContext(ConstantsContext)
    const user = useRecoilValue(userAtom)
    const [deleting, setDeleting] = useState(false)
    const [selectedIds, setSelectedIds] = useState([])

    const handleSetDate = () =>
        LocalStorage.getJustCreatedConstantDate().then((date) => {
            if (date !== null) {
                setConstantDate(date)
            }
        })

    const handleDeleteBtn = () => {
        setDeleting(true)
        const payload = {
            patientId: user.id,
            constantVitalSignTypeIds: selectedIds
        }
        UserService.deleteConstants(payload)
            .then((res) => {
                setDeleting(false)
                ShowToast({ type: "success", message: "Constantes supprimés avec succès" })
                setUpdateList((prev) => !prev)
                toggleModal()
            })
            .catch(() => {
                setDeleting(false)
                ShowToast({
                    type: "error",
                    message: "Une erreur est survenue."
                })
            })
    }

    const handleCheck = (newId) => {
        setSelectedIds((prev) => {
            if (prev?.length > 0) {
                if (prev.includes(newId)) {
                    return prev.filter((id) => id !== newId)
                } else {
                    return [...prev, newId]
                }
            }
            return [newId]
        })
    }

    const checkedItem = (itemId) => {
        if (itemId > 0 && selectedIds?.includes(itemId)) {
            return "checked"
        }
        return "unchecked"
    }

    useEffect(() => {
        handleSetDate()
    }, [])

    const renderItem = ({ item }) => <ConstantLineChart constant={item} setConstantWithValues={setConstantWithValues} />

    return (
        <View style={{ flex: 1, paddingHorizontal: 10 }}>
            <FlatList
                data={constantWithValues}
                contentContainerStyle={{
                    paddingTop: 20,
                    paddingBottom: 150
                }}
                ListHeaderComponent={
                    <>
                        <Spacer height={15} />
                        <OpenSansText fontSize={16}>
                            Consultez vos données ou entrez de nouvelles constantes.
                        </OpenSansText>
                    </>
                }
                ListEmptyComponent={<CustomEmptyData />}
                showsVerticalScrollIndicator={false}
                renderItem={renderItem}
                keyExtractor={(item) => item.id.toString()}
                refreshControl={<RefreshControl refreshing={loading} onRefresh={fetchConstants} />}
            />

            <CustomBottomModal
                title="Sélécionner les contantes à supprimer"
                open={openDeleteModal}
                toggleModal={toggleModal}
            >
                {constantWithValues?.map((constant, index) => (
                    <TouchableOpacity
                        disabled={deleting}
                        onPress={() => handleCheck(constant?.id)}
                        key={index}
                        style={{ flexDirection: "row", alignItems: "center", marginBottom: 15 }}
                    >
                        <CustomCheckBox
                            disabled={deleting}
                            checked={checkedItem(constant?.id) === "checked"}
                            handleCheck={() => handleCheck(constant?.id)}
                            checkBoxColor={baseColors.green.primary}
                        />
                        <OpenSansText style={{ marginLeft: 10, color: baseColors.black, fontSize: 16 }}>
                            {constant?.name ?? ""}
                        </OpenSansText>
                    </TouchableOpacity>
                ))}

                <Button
                    loading={deleting}
                    disabled={selectedIds?.length === 0 || deleting}
                    onPress={handleDeleteBtn}
                    text={deleting ? "Suppression en cours..." : "Supprimer"}
                    width="80%"
                    backgroundColor={baseColors.orange.primary}
                    labelColor={"white"}
                    marginTop={50}
                    marginBottom={150}
                />
            </CustomBottomModal>
        </View>
    )
}
